let api = 'http://' + window.location.hostname + ':8787'
let wsApi = 'ws://' + window.location.hostname + ':8787/websocket/'
// api = "http://101.34.50.153:8787";
// wsApi = "ws://101.34.50.153:8787/websocket/";
// api = "https://dms.bydziot.com";
// wsApi = "wss://dms.bydziot.com/websocket/";


if (process.env.NODE_ENV === "production") {
    api = "https://dms.bydziot.com";
    wsApi = "wss://dms.bydziot.com/websocket/";
}

export { api, wsApi };


// WEBPACK FOOTER //
// ./src/utils/apiConfig.js